import React, {useState} from 'react';
import {Text} from '../Text';
import {cn} from '@/utils/common_functions';

interface TooltipProps {
  message: string;
  children: React.ReactNode;
  className?: string;
  textClassName?: string;
  tooltipClassName?: string;
}
export const Tooltip: React.FC<TooltipProps> = props => {
  const {message, children, className = '', textClassName = '', tooltipClassName=''} = props;
  const [visible, setVisible] = useState(false);

  return (
    <div className={cn('relative inline-block',className)} onMouseEnter={() => setVisible(true)} onMouseLeave={() => setVisible(false)}>
      {children}

      {visible && (
        <div className={cn(`absolute left-1/2 -translate-x-1/2 -top-10 whitespace-nowrap px-3 py-1 rounded-md shadow-md bg-ui_sky_blue`, tooltipClassName)}>
          <Text variant="small" className={cn('text-ui_blue !font-FigtreeMeduim', textClassName)}>
            {message}
          </Text>

          {/* triangle */}
          <div className="absolute left-1/2 -bottom-2 -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-l-transparent border-t-ui_sky_blue border-r-transparent"/>
        </div>
      )}
    </div>
  );
};
